import { dispatch } from "d3"
import { VisualizationComponent } from "../VisualizationComponent"

export type TimeSpan = { start: number, end: number }

export const EEG_WINDOW_TYPES = [VisualizationComponent.EEG_MONTAGE]

export const isEEGWindowType = (windowType: VisualizationComponent) => EEG_WINDOW_TYPES.includes(windowType)

type EEGView = TimeSpan & {
	// Linked or in live mode: the EEG follows the trend windows' time, so marking it adds nothing.
	followsTrends: boolean
}

// The time span each EEG window on screen is showing, so trend windows with "Click to pick a time"
// can mark where the EEG is. Keyed by the window's controller: area letters repeat across displays.
class EEGViewRegistry {
	private views = new Map<object, EEGView>()
	private changes = dispatch<object>("change")

	set = (owner: object, view: EEGView) => {
		const previous = this.views.get(owner)
		if (previous?.start === view.start && previous?.end === view.end && previous?.followsTrends === view.followsTrends) {
			return
		}
		this.views.set(owner, view)
		this.changes.call("change")
	}

	delete = (owner: object) => {
		if (this.views.delete(owner)) {
			this.changes.call("change")
		}
	}

	// The EEG windows worth marking: those at a time of their own, after a jump or unlinked by hand.
	getIndependent = (): TimeSpan[] => Array.from(this.views.values()).filter(view => !view.followsTrends)

	// Listeners are named so each window can replace or remove its own (null removes it).
	onChange = (name: string, listener: (() => void) | null) => {
		this.changes.on(`change.${name}`, listener)
	}
}

export const eegViewRegistry = new EEGViewRegistry()
